import Controller from 'controllers/controller';
import Elements from 'tools/elements';
import jQuery from 'jquery';
import Bootstrap from 'bootstrap';

class InspiredEventsTemplateController extends Controller {
    condition() {
        return this.app.pageTemplateIs('inspired-events', 'inspired-event');
    }

    ready() {
        this.elements = new Elements();

        this.options = {
            emailRegex : /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/i
        };

        this.cacheElements();
        this.attachEvents();
    }

    cacheElements() {
        this.elements.queryOne('form', '#enquiry-form');

        this.elements.queryOne('message', '#enquiry-form .message');
        this.elements.queryOne('messageDismiss', '#enquiry-form .message .dismiss');
        this.elements.queryOne('messageP', '#enquiry-form .message p');

        this.elements.queryOne('submitButton', '#enquiry-form .send');

        let textContent = (this.elements.messageP).textContent;
        this.elements.save('originalContent', textContent);

        this.cacheInputs();
    }

    cacheInputs() {
        this.elements.queryAll('inputs', ('#enquiry-form input, #enquiry-form select, #enquiry-form textarea'));

        this.elements.inputsByName = { };

        this.elements.each('inputs', input => {
            this.elements.inputsByName[ input.getAttribute('name') ] = input;
        });
    }

    attachEvents() {
        this.elements.form.addEventListener('submit', this.onFormSubmit);
        this.elements.messageDismiss.addEventListener('click', this.onMessageDismissClick);

        this.elements.submitButton.addEventListener('click', this.preventDefault);

        this.elements.each('inputs', input => {
            // Only fields with validate-on-blur class are to be validated on blur
            if (input.classList.contains('validate-on-blur')) {
                input.addEventListener('blur', this.onValidatedInputBlur);
            }
        });

        if (this.elements.inputsByName['accepted-terms-and-conditions']) {
            this.elements.inputsByName['accepted-terms-and-conditions'].addEventListener('change', this.onAcceptedTermsAndConditionsChange);
        }

        window.triggerContactFormSubmit = () => {
            console.log('g-recaptcha triggerContactFormSubmit');
            this.triggerFormSubmit();
        };
    }

    onFormSubmit(event) {
        console.log('onFormSubmit fired');

        event.preventDefault();

        this.submitForm();
    }

    onMessageDismissClick() {
        TweenLite.to(this.elements.message, 0.5, {
            scale: 0.8,
            opacity: 0.0,
            onComplete: () => {
                this.elements.message.classList.add('hidden');
                this.elements.message.classList.remove('success');
                this.elements.message.classList.remove('failure');
                this.elements.messageP.textContent = this.elements.originalContent;
            }
        });
    }

    preventDefault(event) { console.log(event);
        event.preventDefault();
    }

    onValidatedInputBlur(event) {
        let input = event.currentTarget,
            errors = [ ];

        if ( ! this.validateInput(input, errors)) {
            this.showValidationErrors(errors);
        }
    }

    onAcceptedTermsAndConditionsChange() {
        this.elements.submitButton.disabled = ! event.currentTarget.checked;
    }

    triggerFormSubmit() {
        console.log('triggerFormSubmit');

        this.submitForm();
    }

    submitForm() {
        console.log('submitForm');

        // Update the input cache first to account for dynamically inserted recaptcha
        this.cacheInputs();

        if ( ! this.fieldsAreValid()) {
            // We must reset the captcha for subsequent clicks to work
            grecaptcha.reset();

            return;
        }

        this.elements.form.classList.add('request-in-progress');

        this.sendRequest(this.getFormData())
            .done(json => {
                let response = this.decodeResponse(json);

                this.elements.form.classList.remove('request-in-progress');

                // We must reset the captcha for subsequent clicks to work
                grecaptcha.reset();

                if (response.success) {
                    this.showMessage('success', this.elements.originalContent);
                    this.clearInputs();
                } else {
                    this.handleErrorResponse(response);
                }
            })
            .fail(() => {
                // We must reset the captcha for subsequent clicks to work
                grecaptcha.reset();

                console.error('Failed AJAX request', arguments);
            });
    }

    validateInput(input, errors) {
        let name = input.getAttribute('name'),
            valid = false,
            value;

        // Allow function to be used without passing error array
        if ( ! errors) {
            errors = [ ];
        }

        switch (name) {
            case 'g-recaptcha-response':
                // Not processable on front-end
                break;

            case 'input-name':
                value = input.value.trim();

                if (! value.length) {
                    errors.push([ input, 'Please enter your name' ]);
                } else {
                    valid = true;
                }

                input.value = value;

                break;

            case 'input-email':
                value = input.value.trim();

                if (! value.trim().length) {
                    errors.push([ input, 'Please enter your email' ]);
                } else if (! this.options.emailRegex.test(value)) {
                    errors.push([ input, 'Please enter a valid business email' ]);
                } else {
                    valid = true;
                }

                input.value = value;

                break;

            case 'input-phone':
                value = input.value.trim();

                if (! value.trim().length) {
                    errors.push([ input, 'Please enter your phone number' ]);
                } else {
                    valid = true;
                }

                input.value = value;

                break;

            case 'input-enquiry':
                value = input.value.trim();

                if (value.length === 0) {
                    errors.push([ input, 'Please enter a message' ]);
                } else {
                    valid = true;
                }

                input.value = value;

                break;

            case 'input-send-from-page':
                value = input.value.trim();

                input.value = value;

                break;

            default:
                console.error('Unknown input ', name);
        }

        return valid;
    }

    showValidationErrors(errors) {
        errors.forEach(error => {
            this.showMessageOverInput.apply(null, error);
        });
    }

    fieldsAreValid() {
        let errors = [ ];

        this.elements.each('inputs', input => {
            this.validateInput(input, errors);
        });

        this.showValidationErrors(errors);

        return ! errors.length;
    }

    sendRequest(data) {
        return jQuery.post(this.getApiEndpoint(), {
            data: data
        }, null, 'text').promise();
    }

    getApiEndpoint() {
        let query = this.buildQuery({
            endpoint: 'make-an-enquiry'
        });

        return APP_ROOT + 'ajax/' + query
    }

    buildQuery(variables) {
        let key,
            query = '';

        for (key in variables) {
            if (variables.hasOwnProperty(key)) {
                query += query ? '&' : '?';

                query += key + '=' + variables[key];
            }
        }

        return query;
    }

    getFormData() {
        let formData = { };

        // Get form data
        this.elements.each('inputs', input => {
            formData[ input.getAttribute('name') ] = this.getInputValue(input);
        });
        console.log('formData', formData['g-recaptcha-response']);
        return formData;
    }

    getInputValue(input) {
        if (! input) {
            return null;
        }

        if (input.tagName === 'select') {
            return input.options[ input.selectedIndex ];
        }

        if (input.type === 'checkbox') {
            return input.checked;
        }

        return input.value;
    }

    decodeResponse(response) {
        try {
            return JSON.parse(response);
        } catch (err) {
            console.error('An unknown error occurred, malformed JSON response', err, response);

            alert('An unknown error occurred, please try again.');

            return null;
        }
    }

    showMessage(type, message) {
        TweenLite.set(this.elements.message, {
            scale: 0.8,
            opacity: 0.0
        });

        this.elements.message.classList.remove('hidden');
        this.elements.message.classList.add(type);

        this.elements.messageP.textContent = message;

        TweenLite.to(this.elements.message, 0.5, {
            scale: 1.0,
            opacity: 1.0
        });
    }

    clearInputs() {
        this.elements.each('inputs', input => {
            // Hidden inputs cary metadata about the page the form was submitted from
            if (input.type === 'hidden') {
                return;
            }

            if (input.type === 'checkbox') {
                input.checked = false;

                console.log('trigger checkbox change', input);
                $(input).trigger('change');
            } else {
                input.value = '';
            }
        });

        setTimeout(() => {
            this.elements.submitButton.disabled = true;
        }, 10);
    }

    handleErrorResponse(response) {
        if (response.error_type === 'inputs') {
            this.showResponseErrors(response.errors);
        } else if (response.error_type === 'system') {
            this.showMessage('failure', response.error);
        }
    }

    showResponseErrors(errors) {
        let key;

        for (key in errors) {
            if (errors.hasOwnProperty(key)) {
                this.showMessageOverInput(this.elements.inputsByName[ key ], errors[ key ]);
            }
        }
    }

    showMessageOverInput(input, message) {
        let $input = jQuery(input),
            popoverCloseTimeout = $input.data('popoverCloseTimeout'),
            delay = 20;

        if(popoverCloseTimeout) {
            clearTimeout(popoverCloseTimeout);
            $input.popover('dispose');

            delay = 200;
        }

        setTimeout(() => {
            $input.popover({
                title: '',
                content: message,
                placement: 'top',
                container: 'body',
                trigger: 'manual'
            });

            $input.popover('show');

            $input.data('popoverCloseTimeout', setTimeout(() => {
                $input.popover('dispose');

                $input.data('popoverCloseTimeout', null)
            }, 2500));
        }, delay);
    }
}

export default InspiredEventsTemplateController;


// WEBPACK FOOTER //
// ./site/templates/resources/src/js/controllers/templates/inspired-events.js